"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SplitButton;
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _ButtonGroup = _interopRequireDefault(require("@mui/material/ButtonGroup/ButtonGroup.js"));
var _ClickAwayListener = require("@mui/base/ClickAwayListener");
var _Grow = _interopRequireDefault(require("@mui/material/Grow/Grow.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList/MenuList.js"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper/Paper.js"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper/Popper.js"));
var _styles = require("@mui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  buttonGroup: {
    boxShadow: 'none'
  },
  groupedContained: {
    '&:not(:last-child)': {
      borderRightColor: theme.palette.primary.contrastText
    }
  },
  button: {
    '&:hover': {
      boxShadow: 'none',
      transform: 'none'
    }
  },
  popper: {
    zIndex: 3
  }
}));
function SplitButton({
  options,
  buttonGroupProps = {},
  buttonProps = {}
}) {
  const [open, setOpen] = _react.default.useState(false);
  const anchorRef = _react.default.useRef(null);
  const classes = useStyles();
  const handleMenuItemClick = option => {
    setOpen(false);
    option.onClick();
  };
  function handleToggle() {
    setOpen(open => !open);
  }
  const handleClose = () => {
    setOpen(false);
  };
  const {
    className: groupClass,
    ...btnGroupProps
  } = buttonGroupProps;
  const {
    className: buttonClass,
    ...btnProps
  } = buttonProps;
  const groupClasses = (0, _classnames.default)(classes.buttonGroup, groupClass);
  const buttonClasses = (0, _classnames.default)(classes.button, buttonClass);
  const [primaryOption, ...dropdownOptions] = options;
  const shouldRenderOptions = dropdownOptions.length > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ButtonGroup.default, {
      className: groupClasses,
      classes: {
        groupedContainedPrimary: classes.groupedContained
      },
      disabled: primaryOption.disabled,
      variant: "contained",
      ref: anchorRef,
      ...btnGroupProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        className: buttonClasses,
        onClick: () => primaryOption.onClick(primaryOption),
        ...btnProps,
        children: primaryOption.label
      }), shouldRenderOptions && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        className: classes.button,
        size: "small",
        onClick: handleToggle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowDropDown.default, {})
      })]
    }), shouldRenderOptions && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popper.default, {
      className: classes.popper,
      open: open,
      anchorEl: anchorRef.current,
      transition: true,
      disablePortal: true,
      children: ({
        TransitionProps,
        placement
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grow.default, {
        ...TransitionProps,
        style: {
          transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClickAwayListener.ClickAwayListener, {
            onClickAway: handleClose,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuList.default, {
              children: dropdownOptions.map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                onClick: () => handleMenuItemClick(option),
                disabled: option.disabled,
                children: option.label
              }, option.label))
            })
          })
        })
      })
    })]
  });
}